import React, { useState } from 'react';

import { ToggleButton, ToggleButtonGroup } from '@zillow/constellation';

type Props = {
  noHandler: () => void;
  yesActive: boolean;
  yesHandler: () => void;
  className?: string;
  dataTest?: string;
  disabled?: boolean;
};

export default function YesAndNo({
  className,
  noHandler,
  yesHandler,
  yesActive,
  dataTest,
  disabled,
}: Props): JSX.Element {
  const NO = 'no';
  const YES = 'yes';

  const [buttonState, setButtonState] = useState({
    value: yesActive ? YES : yesActive === false ? NO : null,
  });

  function onToggleButtonGroupChange(value): void {
    if (value === NO) {
      setButtonState({ value: NO });
      noHandler();
    } else if (value === YES) {
      setButtonState({ value: YES });
      yesHandler();
    }
  }

  return (
    <ToggleButtonGroup
      fluid
      className={className}
      onChange={onToggleButtonGroupChange}
      data-test={dataTest}
      value={buttonState.value}
      aria-label="yes or no"
    >
      <ToggleButton aria-label={YES} value={YES} data-test="yes-button" disabled={disabled}>
        Yes
      </ToggleButton>
      <ToggleButton aria-label={NO} value={NO} data-test="no-button" disabled={disabled}>
        No
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
